/*
 * SCRIPTS NB THEME
 * Auteur : Nicolas Blandel - nicoblandel.fr
 *
*/
let lastScrollTop = 0;

$(document).ready( function() {
	// Ancre au chargement de la page <url>#ancre
	if ( window.location.hash ) {
		history.scrollRestoration = "manual";
		if ( $(window.location.hash).length ) {
			var offset = $(window.location.hash).offset().top-$("#header").height();
			$('html, body').animate({scrollTop: offset}, 'slow');
		}
	}

	// Ancres
	if ( $('a.ancre').length || $('.menu-ancre').length ) {
		$('a.ancre, .menu-ancre a').click( function(e) {
			e.preventDefault();
			var tabSlide = $(this).attr("href").split("#");
			if ( tabSlide[1] ) {
				var id = "#"+tabSlide[1];
				var offset = $(id).offset().top-($(window).width()>=760 ? 90 : $("#header").height()) // Header height sticky
			}
			else {
				var offset = 0;
			}
			$('html, body').animate({scrollTop: offset}, 'slow');
			return false;
		});
	}

	// Initialise le sticky Menu
	if ( $(window).width() >= 760 ) {
		stickyMenu();
	}

	// Header avec visuel ou video
	// if ( $("#entry-header").length ) {
	// 	var minheight = $(".entry-header-content").outerHeight() + $("#header").height(); // Marge basse
	// 	if ( $(document).width() >= 760 ) {
	// 		minheight += 160;
	// 	}
	// 	$("#entry-header").css("min-height", minheight);
	// }

	// Top search bar
	if ( $(".top-search").length ) {
		$(".search-link").click( function(e) {
			e.preventDefault();
			$(".top-search").toggleClass("active");
		});

		$(".search-bar").submit(function(e) {
			if ( !$(".search-input").val() ) {
				e.preventDefault();
			}
		});
		var search_timeout;
		$(".search-bar").on("mouseenter", function(e) {
			clearTimeout(search_timeout)
		});
		$(".search-bar").on("mouseleave", function(e) {
			search_timeout = setTimeout( function(e) {
				$(".top-search").removeClass("active");
			}, 1000);
		});
	}

	// Player
	$('.media.video').click(function() {
		if(!$(this).hasClass('showVideo'))  {
			$(this).addClass('showVideo');
			if($(this).find('img').length !== 0) {
				// Lecture des vidéos Youtube et Vimeo
				let videoUrl = $(this).find("iframe").attr('src');
				$(this).find(".video_player iframe").attr('allow', 'autoplay; fullscreen');
				if(videoUrl.split('?').length > 0) videoUrl = videoUrl.split('?')[0];
				$(this).find(".youtube_player iframe").attr('src', videoUrl + '?theme=light&rel=0&controls=1&enablejsapi=1&showinfo=0&autoplay=1');
				$(this).find(".vimeo_player iframe").attr('src', videoUrl + '?autoplay=1');
			}
		}
	});

	// Bloc Onglets
	if ( $(".onglets").length ) {
		$(".onglets").each( function(e) {
			var $parent = $(this)

			$parent.find(".link_tab").click( function(e) {
				e.preventDefault();
				$parent.find(".active").removeClass("active")

				$(this).addClass("active")
				$parent.find($(this).attr("href")).addClass("active")
			})
		})
	}


	if ( $(".newsletter_form").length ) {
		$(".newsletter_form").each( function(e) {
		  $(this).on('submit', function (e) {
		    e.preventDefault();
				let form = $(this);
				let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
				let email = form.find('input[type="email"]').val();
				form.find('.newsletter_error').fadeOut(300);
				if(email === '' || email === ' ' || regex.test(email) === false) {
					form.find('.newsletter_error').fadeIn(300);
				}else {
					form.addClass('loading');
					$.post(form.attr('action'), form.serialize(), function(response) {
						form.removeClass('loading');
						if($(response).find('.form_message.validate').length > 0) {
							form.fadeOut(200, function() {
								form.after($(response).find('.form_message.validate'));
							});
						}else if($(response).find('form_message.error').length > 0) {
							form.after($(response).find('.form_message.error'));
						}
					});
				}
		  });
		})
	}


	// Chargement du body en fondu
	setTimeout( function() {
		$("body").addClass("loaded");
	}, 200);

});

// https://contactform7.com/dom-events/
// wpcf7invalid — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because there are fields with invalid input.
// wpcf7spam — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because a possible spam activity has been detected.
// wpcf7mailsent — Fires when an Ajax form submission has completed successfully, and mail has been sent.
// wpcf7mailfailed — Fires when an Ajax form submission has completed successfully, but it has failed in sending mail.
// wpcf7submit — Fires when an Ajax form submission has completed successfully, regardless of other incidents.

// Listen for when file inputs change
if ( $(".form-file").length ) {
	$(".form-file").each(function(e) {
		var $parent = $(this);
		var $btn = $(this).find("[class^='btn']");
		$(this).find("[class^='btn']").click(function(e) {
			e.preventDefault();
			$parent.find("input[type='file']").trigger("click");
		});
		$(this).find("input[type='file']").on("change", function() {
			if ( $(this)[0].files.length ) {
				$btn.addClass("complete");
			}
			else {
				$btn.removeClass("complete");
			}
		});
	});
}

if ( $('.wpcf7').length ) {
	$('.wpcf7').each( function(e) {
		var $this = $(this);

		// A la soumission
		$this.find("[type='submit']").click(function(e) {
			$this.addClass("loadin");
		})

		// Si erreur
		$this[0].addEventListener( 'wpcf7invalid', function( event ) {
			$this.find(".screen-reader-response").addClass("error").removeClass("succes");
			$this.removeClass("loadin");

			var offset = $this.offset().top-$("#header").height();
			$('html, body').animate({scrollTop: offset}, 'slow');
		}, false );

		// Si succes
		$this[0].addEventListener( 'wpcf7mailsent', function( event ) {
			$this.find(".screen-reader-response").removeClass("error").addClass("succes");
			$this.removeClass("loadin");

			var offset = $this.offset().top-$("#header").height();
			$('html, body').animate({scrollTop: offset}, 'slow');
		}, false );
	});
}

// Gestion du Scroll
$(window).on("scroll", function(e) {
	stickyMenu();
});

// Sticky menu
function stickyMenu() {
	// Passe le menu en sticky
	if ( !$("body").hasClass("sticky-fix") ) {
		if ( $(window).scrollTop() > 55 && !$("body").hasClass("sticky") ) {
			$("body").addClass("sticky");
		}
		else if ( $(window).scrollTop() <= 55 ) {
			$("body").removeClass("sticky");
		}
	}
	
	// Si on scroll vers le bas on cache le mega menu
	if($(window).width() >= 780) {
		let st = window.scrollY;
		if(st > lastScrollTop) {
			$("#prim-nav").removeClass("show")
			$("body").removeClass("menu-active")
			$("#prim-nav .nav-menu > .menu-item.active").removeClass("active")
		}
		lastScrollTop = st
	}
}
